<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="商品名" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入商品名模糊查询" v-model="queryParam.search" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="售卖" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="全部" v-model="queryParam.sellable" allowClear>
                    <a-select-option value="1">售卖中</a-select-option>
                    <a-select-option value="0">已停售</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="handleBind" type="primary" icon="plus">新增绑定</a-button>
        </div>
        <!-- table区域 -->
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :scroll="scroll"
          :loading="loading"
          @change="handleTableChange">
          <template slot="imgSlot" slot-scope="text, record">
            <img v-if="getImgUrl(record.imgName)" :src="getImgUrl(record.imgName)" class="goods-thumb" />
            <span v-else>-</span>
          </template>
          <template slot="sellableSlot" slot-scope="text, record">
            <a-switch
              size="small"
              :checked="record.sellable === '1'"
              :loading="switchingKey === record.id + '-sellable'"
              @click="() => toggleFlag(record, 'sellable')" />
          </template>
          <template slot="soldOutSlot" slot-scope="text, record">
            <a-switch
              size="small"
              :checked="record.soldOut === '1'"
              :loading="switchingKey === record.id + '-soldOut'"
              @click="() => toggleFlag(record, 'soldOut')" />
          </template>
          <template slot="sortSlot" slot-scope="text, record">
            <a-input-number
              v-model="record.sort"
              :min="0"
              :precision="0"
              style="width: 70px"
              @focus="() => onSortFocus(record)"
              @blur="() => saveSort(record)" />
          </template>
          <span slot="action" slot-scope="text, record">
            <a @click="handleOptions(record)">选项设置</a>
            <a-divider type="vertical" />
            <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="删除后该商品的选项组/值将一并删除，确定删除吗？" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <!-- 绑定商品弹窗 -->
        <goods-bind-modal ref="bindModal" @ok="modalFormOk"></goods-bind-modal>
        <!-- 选项设置弹窗 -->
        <option-groups-modal ref="optionModal"></option-groups-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import GoodsBindModal from './GoodsBindModal'
import OptionGroupsModal from './OptionGroupsModal'
import { goodsDelete, goodsUpdate } from '@/api/plugin/dining'
import { getFileAccessHttpUrl } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

/**
 * 菜品设置（Task 9）：商品与餐饮扩展绑定列表
 * 行内：售卖/估清开关、排序失焦保存；选项设置进 OptionGroupsModal
 * 注意：后端 /goods/list 接收扁平参数 search(商品名模糊)/sellable，
 * 与主框架 queryParam→search=JSON 的默认模式不同，故覆写 getQueryParams
 */
export default {
  name: 'GoodsList',
  mixins: [JeecgListMixin],
  components: {
    GoodsBindModal,
    OptionGroupsModal
  },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17, offset: 1 },
      urlPath: '/plugin/dining/goods',
      queryParam: {
        search: '',
        sellable: ''
      },
      switchingKey: '',
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 50,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        { title: '商品图', dataIndex: 'imgName', width: 80, align: 'center', scopedSlots: { customRender: 'imgSlot' } },
        { title: '商品名', dataIndex: 'materialName', width: 160, align: 'left' },
        { title: '分类', dataIndex: 'categoryName', width: 100, align: 'center',
          customRender: function(text) { return text || '-' } },
        { title: '最低价', dataIndex: 'minPrice', width: 80, align: 'right',
          customRender: function(text) { return text === null || text === undefined || text === '' ? '-' : text } },
        { title: '售卖', dataIndex: 'sellable', width: 70, align: 'center', scopedSlots: { customRender: 'sellableSlot' } },
        { title: '估清', dataIndex: 'soldOut', width: 70, align: 'center', scopedSlots: { customRender: 'soldOutSlot' } },
        { title: '描述', dataIndex: 'description', width: 150, align: 'left',
          customRender: function(text) { return text || '-' } },
        { title: '排序', dataIndex: 'sort', width: 90, align: 'center', scopedSlots: { customRender: 'sortSlot' } },
        { title: '操作', dataIndex: 'action', width: 120, align: 'center', scopedSlots: { customRender: 'action' } }
      ],
      url: {
        list: '/api/plugin/dining/goods/list'
      }
    }
  },
  methods: {
    /** 覆写 mixin：后端为扁平参数（search=商品名模糊串、sellable=0/1），非 JSON search */
    getQueryParams() {
      const params = {
        search: (this.queryParam.search || '').trim(),
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize
      }
      if (this.queryParam.sellable === '0' || this.queryParam.sellable === '1') {
        params.sellable = this.queryParam.sellable
      }
      return params
    },
    searchReset() {
      this.queryParam = { search: '', sellable: '' }
      this.loadData(1)
    },
    getImgUrl(imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      }
      return ''
    },
    handleBind() {
      this.$refs.bindModal.open()
    },
    handleOptions(record) {
      this.$refs.optionModal.open(record)
    },
    /** 行内售卖/估清开关（不走按钮权限） */
    toggleFlag(record, field) {
      const key = record.id + '-' + field
      if (this.switchingKey === key) {
        return
      }
      const next = record[field] === '1' ? '0' : '1'
      this.switchingKey = key
      goodsUpdate(record.id, { [field]: next }).then((res) => {
        if (res.code === 200) {
          record[field] = next
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.switchingKey = ''
      })
    },
    onSortFocus(record) {
      record._sortBefore = record.sort
    },
    /** 排序失焦保存（值变化才提交） */
    saveSort(record) {
      if (record.sort === record._sortBefore) {
        return
      }
      if (record.sort === null || record.sort === undefined) {
        record.sort = record._sortBefore
        return
      }
      goodsUpdate(record.id, { sort: record.sort }).then((res) => {
        if (res.code === 200) {
          this.$message.success('排序已保存')
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    handleDelete(id) {
      goodsDelete(id).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.goods-thumb { width: 50px; height: 50px; object-fit: cover; border-radius: 4px; border: 1px solid #eee; }
</style>
